import { Initializer } from 'common/types/initializers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

type AppointmentTooltipInitializerProps = {
  node: HTMLElement;
  onMouseLeave: () => void;
  eventElement: HTMLElement;
  viewFinanceData: boolean;
};

export const AppointmentTooltipInitializer = (
  props: AppointmentTooltipInitializerProps,
): Initializer => {
  const { node: parentNode, ...tooltipProps } = props;
  const node = getOrAppendChild({
    id: 'calendar-appointment-tooltip-container',
    parentNode,
  });
  const destroy = () => ReactDOM.unmountComponentAtNode(node);

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="AppointmentTooltip"
        props={{
          ...tooltipProps,
        }}
      />,
      node,
    );
  };

  return { destroy, render };
};
